import { HttpErrorResponse } from '@angular/common/http';

/**
 * A refresh-token failure is treated as "session invalid" for 400/401/403
 * (rejected/expired refresh token), and for status 0 while online (a
 * network-level rejection, commonly a CORS-masked auth failure). Genuine
 * 5xx or true offline (navigator.onLine === false) are kept as transient
 * failures so the user isn't force-logged-out during an outage.
 */
export function isSessionInvalidRefreshFailure(error: HttpErrorResponse): boolean {
  if ([400, 401, 403].includes(error.status)) {
    return true;
  }
  if (error.status === 0) {
    return navigator.onLine;
  }
  return false;
}
